import { $el, $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { ProductForm } from './product-form'

const FOOTER_SELECTOR = '.shopify-section.shopify-section-footer'
const FORM_SELECTOR = 'product-form'

export class ProductFormButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(window, 'scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    const form: ProductForm = $elParent(FORM_SELECTOR, this)

    if (!form) {
      return
    }

    const footer = $el(FOOTER_SELECTOR)
    const point = form.offsetTop + form.offsetHeight
    const footerOffsetTop = footer ? footer.offsetTop : 0
    const isOverFooter = window.innerHeight + window.scrollY < footerOffsetTop
    const isVisible = isOverFooter && window.scrollY > point

    this.classList.toggle('is-visible', isVisible)
    document.body.toggleAttribute('is-product-form-button-fixed', isVisible)
  }
}
